import { SET_ANNOTATION, UPDATE_STATE } from '../actions';
import { TOOLS_IDS } from './constants';
import imageToBase64 from './imageToBase64';
import loadImageFile from './loadImageFile';
import randomId from './randomId';
import replaceImageAnnotationSource from './replaceImageAnnotationSource';

const ADDED_IMG_SPACING_PERCENT = 0.15;

/**
 * Add a new image annotation or replace the selected image layer from a File/Blob.
 * @returns {Promise<boolean>} true when an image was applied
 */
const applyImageFileToCanvas = async ({
  file,
  dispatch,
  annotations = {},
  selectionsIds = [],
  shownImageDimensions = {},
  adjustments: { crop = {} } = {},
}) => {
  if (!file?.type?.startsWith('image/')) {
    return false;
  }

  let loadedImg;
  try {
    loadedImg = await loadImageFile(file);
  } catch {
    return false;
  }

  const dataUrl = imageToBase64(loadedImg);
  const selectedId = selectionsIds[0];
  const selected = selectedId ? annotations[selectedId] : null;

  if (
    selectionsIds.length === 1 &&
    selected?.name === TOOLS_IDS.IMAGE &&
    !selected?.locked
  ) {
    const replaced = replaceImageAnnotationSource(selected, loadedImg, dataUrl);
    if (replaced) {
      dispatch({ type: SET_ANNOTATION, payload: replaced });
      return true;
    }
  }

  const layerWidth = crop.width || shownImageDimensions.width;
  const layerHeight = crop.height || shownImageDimensions.height;
  const layerCropX = crop.x || 0;
  const layerCropY = crop.y || 0;

  const newImgRatio = Math.min(
    1,
    layerWidth / (loadedImg.width + loadedImg.width * ADDED_IMG_SPACING_PERCENT),
    layerHeight /
      (loadedImg.height + loadedImg.height * ADDED_IMG_SPACING_PERCENT),
  );

  const newId = randomId(TOOLS_IDS.IMAGE);

  dispatch({
    type: UPDATE_STATE,
    payload: {
      isDesignState: true,
      annotations: {
        [newId]: {
          id: newId,
          name: TOOLS_IDS.IMAGE,
          image: dataUrl,
          opacity: 1,
          x: layerCropX + layerWidth / 2 - (loadedImg.width * newImgRatio) / 2,
          y: layerCropY + layerHeight / 2 - (loadedImg.height * newImgRatio) / 2,
          width: loadedImg.width * newImgRatio,
          height: loadedImg.height * newImgRatio,
          scaleX: 1,
          scaleY: 1,
          rotation: 0,
        },
      },
      selectionsIds: [newId],
    },
  });

  return true;
};

export default applyImageFileToCanvas;
